export default { sha: '2a19ad10cffe62a7ba0bb0ca90a4347f28ff5f93', buildNumber: 'undefined' }
